// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item[data-v-bffe6b96]{width:calc(100% - 30px)}\r\n", ""]);
// Exports
module.exports = exports;
